"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9508],{

/***/ 509107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ EditorContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const EditorContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);




/***/ }),

/***/ 892274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ NodeHelpers; }
/* harmony export */ });
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60599);
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(182052);
/* harmony import */ var tiny_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(668564);
/* harmony import */ var _utils_getNodesFromSelector_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(633514);
/* harmony import */ var _utils_serializeNode_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(832760);





function NodeHelpers(state, id) {
  (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(typeof id == "string", _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_INVALID_NODE_ID */ .ZW);
  const node = state.nodes[id];
  const nodeHelpers = (id2) => NodeHelpers(state, id2);
  return {
    isCanvas() {
      return !!node.data.isCanvas;
    },
    isRoot() {
      return node.id === _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ROOT_NODE */ .QS;
    },
    isLinkedNode() {
      return node.data.parent && nodeHelpers(node.data.parent).linkedNodes().includes(node.id);
    },
    isTopLevelNode() {
      return this.isRoot() || this.isLinkedNode();
    },
    isDeletable() {
      return !this.isTopLevelNode();
    },
    isParentOfTopLevelNodes: () => node.data.linkedNodes && Object.keys(node.data.linkedNodes).length > 0,
    isParentOfTopLevelCanvas() {
      (0,_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_2__/* .deprecationWarning */ .d)("query.node(id).isParentOfTopLevelCanvas", {
        suggest: "query.node(id).isParentOfTopLevelNodes"
      });
      return this.isParentOfTopLevelNodes();
    },
    isSelected() {
      return state.events.selected.has(id);
    },
    isHovered() {
      return state.events.hovered.has(id);
    },
    isDragged() {
      return state.events.dragged.has(id);
    },
    get() {
      return node;
    },
    ancestors(deep = false) {
      function appendParentNode(id2, ancestors = [], depth = 0) {
        const node2 = state.nodes[id2];
        if (!node2) {
          return ancestors;
        }
        ancestors.push(id2);
        if (!node2.data.parent) {
          return ancestors;
        }
        if (deep || !deep && depth === 0) {
          ancestors = appendParentNode(node2.data.parent, ancestors, depth + 1);
        }
        return ancestors;
      }
      return appendParentNode(node.data.parent);
    },
    descendants(deep = false, includeOnly) {
      function appendChildNode(id2, descendants = [], depth = 0) {
        if (deep || !deep && depth === 0) {
          const node2 = state.nodes[id2];
          if (!node2) {
            return descendants;
          }
          if (includeOnly !== "childNodes") {
            const linkedNodes = nodeHelpers(id2).linkedNodes();
            linkedNodes.forEach((nodeId) => {
              descendants.push(nodeId);
              descendants = appendChildNode(nodeId, descendants, depth + 1);
            });
          }
          if (includeOnly !== "linkedNodes") {
            const childNodes = nodeHelpers(id2).childNodes();
            childNodes.forEach((nodeId) => {
              descendants.push(nodeId);
              descendants = appendChildNode(nodeId, descendants, depth + 1);
            });
          }
          return descendants;
        }
        return descendants;
      }
      return appendChildNode(id);
    },
    linkedNodes() {
      return Object.values(node.data.linkedNodes || {});
    },
    childNodes() {
      return node.data.nodes || [];
    },
    isDraggable(onError) {
      try {
        const targetNode = node;
        (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(!this.isTopLevelNode(), _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MOVE_TOP_LEVEL_NODE */ .sS);
        (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
          NodeHelpers(state, targetNode.data.parent).isCanvas(),
          _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MOVE_NONCANVAS_CHILD */ .Cz
        );
        (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
          targetNode.rules.canDrag(targetNode, nodeHelpers),
          _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_CANNOT_DRAG */ .Ut
        );
        return true;
      } catch (err) {
        if (onError) {
          onError(err);
        }
        return false;
      }
    },
    isDroppable(selector, onError) {
      const targets = (0,_utils_getNodesFromSelector_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getNodesFromSelector */ .t)(state.nodes, selector);
      const newParentNode = node;
      try {
        (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this.isCanvas(), _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MOVE_TO_NONCANVAS_PARENT */ .Ph);
        (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
          newParentNode.rules.canMoveIn(
            targets.map((selector2) => selector2.node),
            newParentNode,
            nodeHelpers
          ),
          _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MOVE_INCOMING_PARENT */ .aL
        );
        const parentNodes = {};
        targets.forEach(({ node: targetNode, exists }) => {
          (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
            targetNode.rules.canDrop(newParentNode, targetNode, nodeHelpers),
            _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MOVE_CANNOT_DROP */ ["if"]
          );
          if (!exists) {
            return;
          }
          (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
            !nodeHelpers(targetNode.id).isTopLevelNode(),
            _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MOVE_TOP_LEVEL_NODE */ .sS
          );
          const targetDeepNodes = nodeHelpers(targetNode.id).descendants(true);
          (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
            !targetDeepNodes.includes(newParentNode.id) && newParentNode.id !== targetNode.id,
            _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MOVE_TO_DESCENDANT */ .iO
          );
          const currentParentNode = targetNode.data.parent && state.nodes[targetNode.data.parent];
          (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
            currentParentNode.data.isCanvas,
            _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MOVE_NONCANVAS_CHILD */ .Cz
          );
          (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
            currentParentNode || !currentParentNode && !state.nodes[targetNode.id],
            _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_DUPLICATE_NODEID */ .UE
          );
          if (currentParentNode.id !== newParentNode.id) {
            if (!parentNodes[currentParentNode.id]) {
              parentNodes[currentParentNode.id] = [];
            }
            parentNodes[currentParentNode.id].push(targetNode);
          }
        });
        Object.keys(parentNodes).forEach((parentNodeId) => {
          const childNodes = parentNodes[parentNodeId];
          const parentNode = state.nodes[parentNodeId];
          (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
            parentNode.rules.canMoveOut(childNodes, parentNode, nodeHelpers),
            _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MOVE_OUTGOING_PARENT */ .sk
          );
        });
        return true;
      } catch (err) {
        if (onError) {
          onError(err);
        }
        return false;
      }
    },
    toSerializedNode() {
      return (0,_utils_serializeNode_es_js__WEBPACK_IMPORTED_MODULE_4__/* .serializeNode */ .U)(node.data, state.options.resolver);
    },
    toNodeTree(includeOnly) {
      const nodes = [id, ...this.descendants(true, includeOnly)].reduce(
        (accum, descendantId) => {
          accum[descendantId] = nodeHelpers(descendantId).get();
          return accum;
        },
        {}
      );
      return {
        rootNodeId: id,
        nodes
      };
    },
    decendants(deep = false) {
      (0,_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_2__/* .deprecationWarning */ .d)("query.node(id).decendants", {
        suggest: "query.node(id).descendants"
      });
      return this.descendants(deep);
    },
    isTopLevelCanvas() {
      return !this.isRoot() && !node.data.parent;
    }
  };
}




/***/ }),

/***/ 596509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ QueryMethods; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/getDOMInfo.es.js
var getDOMInfo_es = __webpack_require__(914785);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/constants.es.js
var constants_es = __webpack_require__(60599);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/deprecate.es.js
var deprecate_es = __webpack_require__(182052);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/cache/tiny-invariant-npm-1.2.0-024338c59c-e09a718a7c.zip/node_modules/tiny-invariant/dist/tiny-invariant.esm.js
var tiny_invariant_esm = __webpack_require__(668564);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/EventHelpers.es.js
function EventHelpers(state, eventType) {
  const event = state.events[eventType];
  return {
    contains(id) {
      return event.has(id);
    },
    isEmpty() {
      return this.all().length === 0;
    },
    first() {
      const values = this.all();
      return values[0];
    },
    last() {
      const values = this.all();
      return values[values.length - 1];
    },
    all() {
      return Array.from(event);
    },
    size() {
      return this.all().length;
    },
    at(i) {
      return this.all()[i];
    },
    raw() {
      return event;
    }
  };
}



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/NodeHelpers.es.js
var NodeHelpers_es = __webpack_require__(892274);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/findPosition.es.js
var findPosition_es = __webpack_require__(581906);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/createNode.es.js
var createNode_es = __webpack_require__(886968);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/deserializeNode.es.js
var deserializeNode_es = __webpack_require__(889374);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/fromEntries.es.js
var fromEntries_es = __webpack_require__(395502);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/getNodesFromSelector.es.js
var getNodesFromSelector_es = __webpack_require__(633514);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/mergeTrees.es.js
var mergeTrees_es = __webpack_require__(606494);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/parseNodeFromJSX.es.js
var parseNodeFromJSX_es = __webpack_require__(238636);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/resolveComponent.es.js
var resolveComponent_es = __webpack_require__(798154);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/query.es.js














var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function QueryMethods(state) {
  const options = state && state.options;
  const _ = () => QueryMethods(state);
  return {
    getDropPlaceholder: (source, target, pos, nodesToDOM = (node) => state.nodes[node.id].dom) => {
      const targetNode = state.nodes[target], isTargetCanvas = _().node(targetNode.id).isCanvas();
      const targetParent = isTargetCanvas ? targetNode : state.nodes[targetNode.data.parent];
      if (!targetParent)
        return;
      const targetParentNodes = targetParent.data.nodes || [];
      const dimensionsInContainer = targetParentNodes ? targetParentNodes.reduce((result, id) => {
        const dom = nodesToDOM(state.nodes[id]);
        if (dom) {
          const info = __spreadValues({
            id
          }, (0,getDOMInfo_es/* getDOMInfo */.e)(dom));
          result.push(info);
        }
        return result;
      }, []) : [];
      const dropAction = (0,findPosition_es/* default */.Z)(
        targetParent,
        dimensionsInContainer,
        pos.x,
        pos.y
      );
      const currentNode = targetParentNodes.length && state.nodes[targetParentNodes[dropAction.index]];
      const output = {
        placement: __spreadProps(__spreadValues({}, dropAction), {
          currentNode
        }),
        error: null
      };
      const sourceNodes = (0,getNodesFromSelector_es/* getNodesFromSelector */.t)(state.nodes, source);
      sourceNodes.forEach(({ node, exists }) => {
        if (exists) {
          _().node(node.id).isDraggable((err) => output.error = err);
        }
      });
      _().node(targetParent.id).isDroppable(source, (err) => output.error = err);
      return output;
    },
    getOptions() {
      return options;
    },
    getNodes() {
      return state.nodes;
    },
    node(id) {
      return (0,NodeHelpers_es/* NodeHelpers */.a)(state, id);
    },
    getSerializedNodes() {
      const nodePairs = Object.keys(state.nodes).map((id) => [
        id,
        this.node(id).toSerializedNode()
      ]);
      return (0,fromEntries_es/* fromEntries */.s)(nodePairs);
    },
    getEvent(eventType) {
      return EventHelpers(state, eventType);
    },
    serialize() {
      return JSON.stringify(this.getSerializedNodes());
    },
    parseReactElement: (reactElement) => ({
      toNodeTree(normalize) {
        const node = (0,parseNodeFromJSX_es/* parseNodeFromJSX */.t)(reactElement, (node2, jsx) => {
          const name = (0,resolveComponent_es/* resolveComponent */.u)(state.options.resolver, node2.data.type);
          node2.data.displayName = node2.data.displayName || name;
          node2.data.name = name;
          if (normalize) {
            normalize(node2, jsx);
          }
        });
        let childrenNodes = [];
        if (reactElement.props && reactElement.props.children) {
          childrenNodes = react.Children.toArray(
            reactElement.props.children
          ).reduce((accum, child) => {
            if (react.isValidElement(child)) {
              accum.push(_().parseReactElement(child).toNodeTree(normalize));
            }
            return accum;
          }, []);
        }
        return (0,mergeTrees_es/* mergeTrees */.X)(node, childrenNodes);
      }
    }),
    parseSerializedNode: (serializedNode) => ({
      toNode(normalize) {
        const data = (0,deserializeNode_es/* deserializeNode */.u)(serializedNode, state.options.resolver);
        (0,tiny_invariant_esm/* default */.Z)(data.type, constants_es/* ERROR_NOT_IN_RESOLVER */.Wt);
        const id = typeof normalize === "string" && normalize;
        if (id) {
          (0,deprecate_es/* deprecationWarning */.d)(`query.parseSerializedNode(...).toNode(id)`, {
            suggest: `query.parseSerializedNode(...).toNode(node => node.id = id)`
          });
        }
        return _().parseFreshNode(__spreadProps(__spreadValues({}, id ? { id } : {}), {
          data
        })).toNode(!id && normalize);
      }
    }),
    parseFreshNode: (node) => ({
      toNode(normalize) {
        return (0,createNode_es/* createNode */.d)(node, (node2) => {
          if (node2.data.parent === constants_es/* DEPRECATED_ROOT_NODE */.CD) {
            node2.data.parent = constants_es/* ROOT_NODE */.QS;
          }
          const name = (0,resolveComponent_es/* resolveComponent */.u)(state.options.resolver, node2.data.type);
          (0,tiny_invariant_esm/* default */.Z)(name !== null, constants_es/* ERROR_NOT_IN_RESOLVER */.Wt);
          node2.data.displayName = node2.data.displayName || name;
          node2.data.name = name;
          if (normalize) {
            normalize(node2);
          }
        });
      }
    }),
    createNode(reactElement, extras) {
      (0,deprecate_es/* deprecationWarning */.d)(`query.createNode(${reactElement})`, {
        suggest: `query.parseReactElement(${reactElement}).toNodeTree()`
      });
      const tree = this.parseReactElement(reactElement).toNodeTree();
      const node = tree.nodes[tree.rootNodeId];
      if (!extras) {
        return node;
      }
      if (extras.id) {
        node.id = extras.id;
      }
      if (extras.data) {
        node.data = __spreadValues(__spreadValues({}, node.data), extras.data);
      }
      return node;
    },
    getState() {
      return state;
    }
  };
}




/***/ }),

/***/ 185105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LO": function() { return /* binding */ ActionMethodsWithConfig; },
  "OI": function() { return /* binding */ editorInitialState; },
  "Eh": function() { return /* binding */ useEditorStore; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/useMethods.es.js
var useMethods_es = __webpack_require__(360216);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/constants.es.js
var constants_es = __webpack_require__(60599);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/deprecate.es.js
var deprecate_es = __webpack_require__(182052);
// EXTERNAL MODULE: ../../.yarn/cache/tiny-invariant-npm-1.2.0-024338c59c-e09a718a7c.zip/node_modules/tiny-invariant/dist/tiny-invariant.esm.js
var tiny_invariant_esm = __webpack_require__(668564);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/fromEntries.es.js
var fromEntries_es = __webpack_require__(395502);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/getNodesFromSelector.es.js
var getNodesFromSelector_es = __webpack_require__(633514);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/removeNodeFromEvents.es.js
var removeNodeFromEvents_es = __webpack_require__(973818);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/actions.es.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Methods = (state, query) => {
  const addNodeTreeToParent = (tree, parentId, addNodeType) => {
    const iterateChildren = (id, parentId2) => {
      const node = tree.nodes[id];
      if (typeof node.data.type !== "string") {
        (0,tiny_invariant_esm/* default */.Z)(
          state.options.resolver[node.data.name],
          constants_es/* ERROR_NOT_IN_RESOLVER.replace */.Wt.replace(
            "%node_type%",
            `${node.data.type.name}`
          )
        );
      }
      state.nodes[id] = __spreadProps(__spreadValues({}, node), {
        data: __spreadProps(__spreadValues({}, node.data), {
          parent: parentId2
        })
      });
      if (node.data.nodes.length > 0) {
        delete state.nodes[id].data.props.children;
        node.data.nodes.forEach(
          (childNodeId) => iterateChildren(childNodeId, node.id)
        );
      }
      Object.values(node.data.linkedNodes).forEach(
        (linkedNodeId) => iterateChildren(linkedNodeId, node.id)
      );
    };
    iterateChildren(tree.rootNodeId, parentId);
    if (!parentId) {
      (0,tiny_invariant_esm/* default */.Z)(
        tree.rootNodeId === constants_es/* ROOT_NODE */.QS,
        "Cannot add non-root Node without a parent"
      );
      return;
    }
    const parent = getParentAndValidate(parentId);
    if (addNodeType.type === "child") {
      const index = addNodeType.index;
      if (index != null) {
        parent.data.nodes.splice(index, 0, tree.rootNodeId);
      } else {
        parent.data.nodes.push(tree.rootNodeId);
      }
      return;
    }
    parent.data.linkedNodes[addNodeType.id] = tree.rootNodeId;
  };
  const getParentAndValidate = (parentId) => {
    (0,tiny_invariant_esm/* default */.Z)(parentId, constants_es/* ERROR_NOPARENT */.ab);
    const parent = state.nodes[parentId];
    (0,tiny_invariant_esm/* default */.Z)(parent, constants_es/* ERROR_INVALID_NODEID */.YN);
    return parent;
  };
  const deleteNode = (id) => {
    const targetNode = state.nodes[id], parentNode = state.nodes[targetNode.data.parent];
    if (targetNode.data.nodes) {
      [...targetNode.data.nodes].forEach((childId) => deleteNode(childId));
    }
    if (targetNode.data.linkedNodes) {
      Object.values(targetNode.data.linkedNodes).map(
        (linkedNodeId) => deleteNode(linkedNodeId)
      );
    }
    const isChildNode = parentNode.data.nodes.includes(id);
    if (isChildNode) {
      const parentChildren = parentNode.data.nodes;
      parentChildren.splice(parentChildren.indexOf(id), 1);
    } else {
      const linkedId = Object.keys(parentNode.data.linkedNodes).find(
        (id2) => parentNode.data.linkedNodes[id2] === id2
      );
      if (linkedId) {
        delete parentNode.data.linkedNodes[linkedId];
      }
    }
    (0,removeNodeFromEvents_es/* removeNodeFromEvents */.S)(state, id);
    delete state.nodes[id];
  };
  return {
    addLinkedNodeFromTree(tree, parentId, id) {
      const parent = getParentAndValidate(parentId);
      const existingLinkedNode = parent.data.linkedNodes[id];
      if (existingLinkedNode) {
        deleteNode(existingLinkedNode);
      }
      addNodeTreeToParent(tree, parentId, { type: "linked", id });
    },
    add(nodeToAdd, parentId, index) {
      let nodes = [nodeToAdd];
      if (Array.isArray(nodeToAdd)) {
        (0,deprecate_es/* deprecationWarning */.d)("actions.add(node: Node[])", {
          suggest: "actions.add(node: Node)"
        });
        nodes = nodeToAdd;
      }
      nodes.forEach((node) => {
        addNodeTreeToParent(
          {
            nodes: {
              [node.id]: node
            },
            rootNodeId: node.id
          },
          parentId,
          { type: "child", index }
        );
      });
    },
    addNodeTree(tree, parentId, index) {
      addNodeTreeToParent(tree, parentId, { type: "child", index });
    },
    delete(selector) {
      const targets = (0,getNodesFromSelector_es/* getNodesFromSelector */.t)(state.nodes, selector, {
        existOnly: true,
        idOnly: true
      });
      targets.forEach(({ node }) => {
        (0,tiny_invariant_esm/* default */.Z)(
          !query.node(node.id).isTopLevelNode(),
          constants_es/* ERROR_DELETE_TOP_LEVEL_NODE */.JB
        );
        deleteNode(node.id);
      });
    },
    deserialize(input) {
      const unDeserializedNodeIds = {};
      try {
        const dehydratedNodes = typeof input == "string" ? JSON.parse(input) : input;
        const nodePairs = Object.keys(dehydratedNodes).map((id) => {
          var _a;
          try {
            let nodeId = id;
            if (id === constants_es/* DEPRECATED_ROOT_NODE */.CD) {
              nodeId = constants_es/* ROOT_NODE */.QS;
            }
            return [
              nodeId,
              query.parseSerializedNode(dehydratedNodes[id]).toNode((node) => node.id = nodeId)
            ];
          } catch (e) {
            const nodeData = dehydratedNodes[id];
            console.log(
              `Cannot found resolver ${nodeData.displayName || ((_a = nodeData == null ? void 0 : nodeData.type) == null ? void 0 : _a.resolvedName)}`
            );
            unDeserializedNodeIds[id] = true;
          }
        }).filter(Boolean);
        if (!Object.keys(unDeserializedNodeIds).length)
          nodePairs.forEach(([_, nodeInfo]) => {
            var _a, _b;
            if (typeof nodeInfo !== "string" && ((_b = (_a = nodeInfo == null ? void 0 : nodeInfo.data) == null ? void 0 : _a.nodes) == null ? void 0 : _b.length)) {
              const filterChildren = nodeInfo.data.nodes.filter(
                (nodeId) => !unDeserializedNodeIds[nodeId]
              );
              nodeInfo.data.nodes = filterChildren;
            }
          });
        this.replaceNodes((0,fromEntries_es/* fromEntries */.s)(nodePairs));
      } catch (e) {
        console.error(e);
      }
    },
    move(selector, newParentId, index) {
      const targets = (0,getNodesFromSelector_es/* getNodesFromSelector */.t)(state.nodes, selector, {
        existOnly: true
      });
      const newParent = state.nodes[newParentId];
      const nodesArrToCleanup = /* @__PURE__ */ new Set();
      targets.forEach(({ node: targetNode }, i) => {
        const targetId = targetNode.id;
        const currentParentId = targetNode.data.parent;
        query.node(newParentId).isDroppable([targetId], (err) => {
          throw new Error(err);
        });
        state.options.onBeforeMoveEnd(
          targetNode,
          newParent,
          state.nodes[currentParentId]
        );
        const currentParent = state.nodes[currentParentId];
        const currentParentNodes = currentParent.data.nodes;
        nodesArrToCleanup.add(currentParentNodes);
        const oldIndex = currentParentNodes.indexOf(targetId);
        currentParentNodes[oldIndex] = "$$";
        newParent.data.nodes.splice(index + i, 0, targetId);
        state.nodes[targetId].data.parent = newParentId;
      });
      nodesArrToCleanup.forEach((nodes) => {
        const length = nodes.length;
        [...nodes].reverse().forEach((value, index2) => {
          if (value !== "$$") {
            return;
          }
          nodes.splice(length - 1 - index2, 1);
        });
      });
    },
    replaceNodes(nodes) {
      this.clearEvents();
      state.nodes = nodes;
    },
    clearEvents() {
      this.setNodeEvent("selected", null);
      this.setNodeEvent("hovered", null);
      this.setNodeEvent("dragged", null);
      this.setIndicator(null);
    },
    reset() {
      this.clearEvents();
      this.replaceNodes({});
    },
    setOptions(cb) {
      cb(state.options);
    },
    setNodeEvent(eventType, nodeIdSelector) {
      state.events[eventType].forEach((id) => {
        if (state.nodes[id]) {
          state.nodes[id].events[eventType] = false;
        }
      });
      state.events[eventType] = /* @__PURE__ */ new Set();
      if (!nodeIdSelector) {
        return;
      }
      const targets = (0,getNodesFromSelector_es/* getNodesFromSelector */.t)(state.nodes, nodeIdSelector, {
        idOnly: true,
        existOnly: true
      });
      const nodeIds = new Set(targets.map(({ node }) => node.id));
      nodeIds.forEach((id) => {
        state.nodes[id].events[eventType] = true;
      });
      state.events[eventType] = nodeIds;
    },
    setCustom(selector, cb) {
      const targets = (0,getNodesFromSelector_es/* getNodesFromSelector */.t)(state.nodes, selector, {
        idOnly: true,
        existOnly: true
      });
      targets.forEach(({ node }) => cb(state.nodes[node.id].data.custom));
    },
    setDOM(id, dom) {
      if (!state.nodes[id]) {
        return;
      }
      state.nodes[id].dom = dom;
    },
    setIndicator(indicator) {
      if (indicator && (!indicator.placement.parent.dom || indicator.placement.currentNode && !indicator.placement.currentNode.dom))
        return;
      state.indicator = indicator;
    },
    setHidden(id, bool) {
      state.nodes[id].data.hidden = bool;
    },
    setProp(selector, cb) {
      const targets = (0,getNodesFromSelector_es/* getNodesFromSelector */.t)(state.nodes, selector, {
        idOnly: true,
        existOnly: true
      });
      targets.forEach(({ node }) => cb(state.nodes[node.id].data.props));
    },
    selectNode(nodeIdSelector) {
      if (nodeIdSelector) {
        const targets = (0,getNodesFromSelector_es/* getNodesFromSelector */.t)(state.nodes, nodeIdSelector, {
          idOnly: true,
          existOnly: true
        });
        this.setNodeEvent(
          "selected",
          targets.map(({ node }) => node.id)
        );
      } else {
        this.setNodeEvent("selected", null);
      }
      this.setNodeEvent("hovered", null);
    }
  };
};
const ActionMethods = (state, query) => {
  return __spreadProps(__spreadValues({}, Methods(state, query)), {
    setState(cb) {
      const _a = this, actions = __objRest(_a, ["history"]);
      cb(state, actions);
    }
  });
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/query.es.js + 1 modules
var query_es = __webpack_require__(596509);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/DefaultEventHandlers.es.js + 2 modules
var DefaultEventHandlers_es = __webpack_require__(343216);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/store.es.js





var store_es_defProp = Object.defineProperty;
var store_es_defProps = Object.defineProperties;
var store_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var store_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var store_es_hasOwnProp = Object.prototype.hasOwnProperty;
var store_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var store_es_defNormalProp = (obj, key, value) => key in obj ? store_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var store_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (store_es_hasOwnProp.call(b, prop))
      store_es_defNormalProp(a, prop, b[prop]);
  if (store_es_getOwnPropSymbols)
    for (var prop of store_es_getOwnPropSymbols(b)) {
      if (store_es_propIsEnum.call(b, prop))
        store_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var store_es_spreadProps = (a, b) => store_es_defProps(a, store_es_getOwnPropDescs(b));
const editorInitialState = {
  nodes: {},
  events: {
    dragged: /* @__PURE__ */ new Set(),
    selected: /* @__PURE__ */ new Set(),
    hovered: /* @__PURE__ */ new Set()
  },
  indicator: null,
  handlers: null,
  options: {
    onNodesChange: () => null,
    onRender: ({ render }) => render,
    onBeforeMoveEnd: () => null,
    resolver: {},
    enabled: true,
    indicator: {
      error: "red",
      success: "rgb(98, 196, 98)"
    },
    handlers: (store) => new DefaultEventHandlers_es/* DefaultEventHandlers */.q({
      store,
      isMultiSelectEnabled: () => false
    }),
    normalizeNodes: () => {
    }
  }
};
const ActionMethodsWithConfig = {
  methods: ActionMethods,
  ignoreHistoryForActions: [
    "setDOM",
    "setNodeEvent",
    "selectNode",
    "clearEvents",
    "setOptions",
    "setIndicator"
  ],
  normalizeHistory: (state) => {
    Object.keys(state.events).forEach((eventName) => {
      const nodeIds = Array.from(state.events[eventName] || []);
      nodeIds.forEach((id) => {
        if (!state.nodes[id]) {
          state.events[eventName].delete(id);
        }
      });
    });
    Object.keys(state.nodes).forEach((id) => {
      const node = state.nodes[id];
      Object.keys(node.events).forEach((eventName) => {
        const isEventActive = !!node.events[eventName];
        if (isEventActive && state.events[eventName] && !state.events[eventName].has(node.id)) {
          node.events[eventName] = false;
        }
      });
    });
  }
};
const useEditorStore = (options, patchListener) => {
  return (0,useMethods_es/* useMethods */.$)(
    ActionMethodsWithConfig,
    store_es_spreadProps(store_es_spreadValues({}, editorInitialState), {
      options: store_es_spreadValues(store_es_spreadValues({}, editorInitialState.options), options)
    }),
    query_es/* QueryMethods */.n,
    patchListener
  );
};




/***/ }),

/***/ 210289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useInternalEditor; }
/* harmony export */ });
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60599);
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35690);
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(786342);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var tiny_invariant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(668564);
/* harmony import */ var _EditorContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(509107);
/* harmony import */ var _events_EventContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(732789);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function useInternalEditor(collector) {
  const handler = (0,_events_EventContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useEventHandler */ .x)();
  const store = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_EditorContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .EditorContext */ .r);
  (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(store, _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_USE_EDITOR_OUTSIDE_OF_EDITOR_CONTEXT */ .k8);
  const collected = (0,_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_5__/* .useCollector */ .r)(store, collector);
  const connectorsUsage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => handler && handler.createConnectorsUsage(),
    [handler]
  );
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    connectorsUsage.register();
    return () => {
      connectorsUsage.cleanup();
    };
  }, [connectorsUsage]);
  const connectors = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => connectorsUsage && (0,_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_6__/* .wrapConnectorHooks */ .p)(connectorsUsage.connectors),
    [connectorsUsage]
  );
  return __spreadProps(__spreadValues({}, collected), {
    connectors,
    inContext: !!store,
    store
  });
}




/***/ }),

/***/ 844710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ CoreEventHandlers; },
/* harmony export */   "s": function() { return /* binding */ DerivedCoreEventHandlers; }
/* harmony export */ });
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(958050);
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(152298);


class CoreEventHandlers extends _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_0__/* .EventHandlers */ .o {
  handlers() {
    return {
      connect: (el, id) => {
      },
      select: (el, id) => {
      },
      hover: (el, id) => {
      },
      drag: (el, id) => {
      },
      drop: (el, id) => {
      },
      create: (el, UserElement, options) => {
      }
    };
  }
}
class DerivedCoreEventHandlers extends _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .DerivedEventHandlers */ .O {
}




/***/ }),

/***/ 343216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ DefaultEventHandlers; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/platform.es.js
var platform_es = __webpack_require__(639705);
// EXTERNAL MODULE: ../../.yarn/cache/lodash.isfunction-npm-3.0.9-72aaa7f66c-99e54c34b1.zip/node_modules/lodash.isfunction/index.js
var lodash_isfunction = __webpack_require__(708984);
var lodash_isfunction_default = /*#__PURE__*/__webpack_require__.n(lodash_isfunction);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/CoreEventHandlers.es.js
var CoreEventHandlers_es = __webpack_require__(844710);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/constants.es.js
var constants_es = __webpack_require__(60599);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/getDOMInfo.es.js
var getDOMInfo_es = __webpack_require__(914785);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/findPosition.es.js
var findPosition_es = __webpack_require__(581906);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/getNodesFromSelector.es.js
var getNodesFromSelector_es = __webpack_require__(633514);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/Positioner.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const _Positioner = class {
  constructor(store, dragTarget) {
    this.store = store;
    this.dragTarget = dragTarget;
    this.currentIndicator = null;
    this.currentDropTargetId = null;
    this.currentDropTargetCanvasAncestorId = null;
    this.currentTargetId = null;
    this.currentTargetChildDimensions = null;
    this.currentIndicator = null;
    this.dragError = null;
    this.draggedNodes = this.getDraggedNodes();
    this.validateDraggedNodes();
    this.onScrollListener = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScrollListener, true);
  }
  cleanup() {
    window.removeEventListener("scroll", this.onScrollListener, true);
  }
  onScroll(e) {
    const scrollBody = e.target;
    const rootNode = this.store.query.node(constants_es/* ROOT_NODE */.QS).get();
    const shouldClearChildDimensionsCache = scrollBody instanceof Element && rootNode && rootNode.dom && scrollBody.contains(rootNode.dom);
    if (!shouldClearChildDimensionsCache) {
      return;
    }
    this.currentTargetChildDimensions = null;
  }
  getDraggedNodes() {
    if (this.dragTarget.type === "new") {
      return (0,getNodesFromSelector_es/* getNodesFromSelector */.t)(
        this.store.query.getNodes(),
        this.dragTarget.tree.nodes[this.dragTarget.tree.rootNodeId]
      );
    }
    return (0,getNodesFromSelector_es/* getNodesFromSelector */.t)(
      this.store.query.getNodes(),
      this.dragTarget.nodes
    );
  }
  validateDraggedNodes() {
    if (this.dragTarget.type === "new") {
      return;
    }
    this.draggedNodes.forEach(({ node, exists }) => {
      if (!exists) {
        return;
      }
      this.store.query.node(node.id).isDraggable((err) => {
        this.dragError = err;
      });
    });
  }
  isNearBorders(domInfo, x, y) {
    const { top, bottom, left, right } = domInfo;
    if (top + _Positioner.BORDER_OFFSET > y || bottom - _Positioner.BORDER_OFFSET < y || left + _Positioner.BORDER_OFFSET > x || right - _Positioner.BORDER_OFFSET < x) {
      return true;
    }
    return false;
  }
  isDiff(newPosition) {
    if (this.currentIndicator && this.currentIndicator.placement.parent.id === newPosition.parent.id && this.currentIndicator.placement.index === newPosition.index && this.currentIndicator.placement.where === newPosition.where) {
      return false;
    }
    return true;
  }
  getChildDimensions(newParentNode) {
    const existingTargetChildDimensions = this.currentTargetChildDimensions;
    if (this.currentTargetId === newParentNode.id && existingTargetChildDimensions) {
      return existingTargetChildDimensions;
    }
    return newParentNode.data.nodes.reduce((result, id) => {
      const dom = this.store.query.node(id).get().dom;
      if (dom) {
        result.push(__spreadValues({
          id
        }, (0,getDOMInfo_es/* getDOMInfo */.e)(dom)));
      }
      return result;
    }, []);
  }
  getCanvasAncestor(dropTargetId) {
    if (dropTargetId === this.currentDropTargetId && this.currentDropTargetCanvasAncestorId) {
      const node = this.store.query.node(this.currentDropTargetCanvasAncestorId).get();
      if (node) {
        return node;
      }
    }
    const getCanvas = (nodeId) => {
      const node = this.store.query.node(nodeId).get();
      if (node && node.data.isCanvas) {
        return node;
      }
      if (!node.data.parent) {
        return null;
      }
      return getCanvas(node.data.parent);
    };
    return getCanvas(dropTargetId);
  }
  computeIndicator(dropTargetId, x, y) {
    let newParentNode = this.getCanvasAncestor(dropTargetId);
    if (!newParentNode) {
      return;
    }
    this.currentDropTargetId = dropTargetId;
    this.currentDropTargetCanvasAncestorId = newParentNode.id;
    if (newParentNode.data.parent && this.isNearBorders((0,getDOMInfo_es/* getDOMInfo */.e)(newParentNode.dom), x, y) && !this.store.query.node(newParentNode.id).isLinkedNode()) {
      newParentNode = this.store.query.node(newParentNode.data.parent).get();
    }
    if (!newParentNode) {
      return;
    }
    this.currentTargetChildDimensions = this.getChildDimensions(newParentNode);
    this.currentTargetId = newParentNode.id;
    const position = (0,findPosition_es/* default */.Z)(
      newParentNode,
      this.currentTargetChildDimensions,
      x,
      y
    );
    if (!this.isDiff(position)) {
      return;
    }
    let error = this.dragError;
    if (!error) {
      this.store.query.node(newParentNode.id).isDroppable(
        this.draggedNodes.map((sourceNode) => sourceNode.node),
        (dropError) => {
          error = dropError;
        }
      );
    }
    const currentNodeId = newParentNode.data.nodes[position.index];
    const currentNode = currentNodeId && this.store.query.node(currentNodeId).get();
    this.currentIndicator = {
      placement: __spreadProps(__spreadValues({}, position), {
        currentNode
      }),
      error
    };
    return this.currentIndicator;
  }
  getIndicator() {
    return this.currentIndicator;
  }
};
let Positioner = _Positioner;
Positioner.BORDER_OFFSET = 10;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/createShadow.es.js
const createShadow = (e, shadowsToCreate, forceSingleShadow = false) => {
  if (shadowsToCreate.length === 1 || forceSingleShadow) {
    const { width, height } = shadowsToCreate[0].getBoundingClientRect();
    const shadow = shadowsToCreate[0].cloneNode(true);
    shadow.style.position = `fixed`;
    shadow.style.left = `-100%`;
    shadow.style.top = `-100%`;
    shadow.style.width = `${width}px`;
    shadow.style.height = `${height}px`;
    shadow.style.pointerEvents = "none";
    document.body.appendChild(shadow);
    e.dataTransfer.setDragImage(shadow, 0, 0);
    return shadow;
  }
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.left = "-100%";
  container.style.top = `-100%`;
  container.style.width = "100%";
  container.style.height = "100%";
  container.style.pointerEvents = "none";
  shadowsToCreate.forEach((dom) => {
    const { width, height, top, left } = dom.getBoundingClientRect();
    const shadow = dom.cloneNode(true);
    shadow.style.position = `absolute`;
    shadow.style.left = `${left}px`;
    shadow.style.top = `${top}px`;
    shadow.style.width = `${width}px`;
    shadow.style.height = `${height}px`;
    container.appendChild(shadow);
  });
  document.body.appendChild(container);
  e.dataTransfer.setDragImage(container, e.clientX, e.clientY);
  return container;
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/DefaultEventHandlers.es.js







const _DefaultEventHandlers = class extends CoreEventHandlers_es/* CoreEventHandlers */.D {
  constructor() {
    super(...arguments);
    this.positioner = null;
    this.currentSelectedElementIds = [];
  }
  onDisable() {
    this.options.store.actions.clearEvents();
  }
  handlers() {
    const store = this.options.store;
    return {
      connect: (el, id) => {
        store.actions.setDOM(id, el);
        return this.reflect((connectors) => {
          connectors.select(el, id);
          connectors.hover(el, id);
          connectors.drop(el, id);
        });
      },
      select: (el, id) => {
        const unbindOnMouseDown = this.addCraftEventListener(
          el,
          "mousedown",
          (e) => {
            e.craft.stopPropagation();
            let newSelectedElementIds = [];
            if (id) {
              const { query } = store;
              const selectedElementIds = query.getEvent("selected").all();
              const isMultiSelect = this.options.isMultiSelectEnabled(e);
              if (isMultiSelect || selectedElementIds.includes(id)) {
                newSelectedElementIds = selectedElementIds.filter(
                  (selectedId) => {
                    const descendants = query.node(selectedId).descendants(true);
                    const ancestors = query.node(selectedId).ancestors(true);
                    if (descendants.includes(id) || ancestors.includes(id)) {
                      return false;
                    }
                    return true;
                  }
                );
              }
              if (!newSelectedElementIds.includes(id)) {
                newSelectedElementIds.push(id);
              }
            }
            store.actions.setNodeEvent("selected", newSelectedElementIds);
          }
        );
        const unbindOnClick = this.addCraftEventListener(el, "click", (e) => {
          e.craft.stopPropagation();
          const { query } = store;
          const selectedElementIds = query.getEvent("selected").all();
          const isMultiSelect = this.options.isMultiSelectEnabled(e);
          const isNodeAlreadySelected = this.currentSelectedElementIds.includes(id);
          let newSelectedElementIds = [...selectedElementIds];
          if (isMultiSelect && isNodeAlreadySelected) {
            newSelectedElementIds.splice(newSelectedElementIds.indexOf(id), 1);
            store.actions.setNodeEvent("selected", newSelectedElementIds);
          } else if (!isMultiSelect && selectedElementIds.length > 1) {
            newSelectedElementIds = [id];
            store.actions.setNodeEvent("selected", newSelectedElementIds);
          }
          this.currentSelectedElementIds = newSelectedElementIds;
        });
        return () => {
          unbindOnMouseDown();
          unbindOnClick();
        };
      },
      hover: (el, id) => {
        const unbindMouseover = this.addCraftEventListener(
          el,
          "mouseover",
          (e) => {
            e.craft.stopPropagation();
            store.actions.setNodeEvent("hovered", id);
          }
        );
        return () => {
          unbindMouseover();
        };
      },
      drop: (el, targetId) => {
        const unbindDragOver = this.addCraftEventListener(
          el,
          "dragover",
          (e) => {
            e.craft.stopPropagation();
            e.preventDefault();
            if (!this.positioner) {
              return;
            }
            const indicator = this.positioner.computeIndicator(
              targetId,
              e.clientX,
              e.clientY
            );
            if (!indicator) {
              return;
            }
            store.actions.setIndicator(indicator);
          }
        );
        const unbindDragEnter = this.addCraftEventListener(
          el,
          "dragenter",
          (e) => {
            e.craft.stopPropagation();
            e.preventDefault();
          }
        );
        return () => {
          unbindDragEnter();
          unbindDragOver();
        };
      },
      drag: (el, id) => {
        if (!store.query.node(id).isDraggable()) {
          return () => {
          };
        }
        el.setAttribute("draggable", "true");
        const unbindDragStart = this.addCraftEventListener(
          el,
          "dragstart",
          (e) => {
            e.craft.stopPropagation();
            const { query, actions } = store;
            let selectedElementIds = query.getEvent("selected").all();
            const isMultiSelect = this.options.isMultiSelectEnabled(e);
            const isNodeAlreadySelected = this.currentSelectedElementIds.includes(id);
            if (!isNodeAlreadySelected) {
              if (isMultiSelect) {
                selectedElementIds = [...selectedElementIds, id];
              } else {
                selectedElementIds = [id];
              }
              store.actions.setNodeEvent("selected", selectedElementIds);
            }
            actions.setNodeEvent("dragged", selectedElementIds);
            const selectedDOMs = selectedElementIds.map(
              (id2) => query.node(id2).get().dom
            );
            this.draggedElementShadow = createShadow(
              e,
              selectedDOMs,
              _DefaultEventHandlers.forceSingleDragShadow
            );
            this.dragTarget = {
              type: "existing",
              nodes: selectedElementIds
            };
            this.positioner = new Positioner(
              this.options.store,
              this.dragTarget
            );
          }
        );
        const unbindDragEnd = this.addCraftEventListener(el, "dragend", (e) => {
          e.craft.stopPropagation();
          this.dropElement((dragTarget, indicator) => {
            if (dragTarget.type === "new") {
              return;
            }
            const index = indicator.placement.index + (indicator.placement.where === "after" ? 1 : 0);
            store.actions.move(
              dragTarget.nodes,
              indicator.placement.parent.id,
              index
            );
          });
        });
        return () => {
          el.setAttribute("draggable", "false");
          unbindDragStart();
          unbindDragEnd();
        };
      },
      create: (el, userElement, options) => {
        el.setAttribute("draggable", "true");
        const unbindDragStart = this.addCraftEventListener(
          el,
          "dragstart",
          (e) => {
            e.craft.stopPropagation();
            let tree;
            if (typeof userElement === "function") {
              const result = userElement();
              if (react.isValidElement(result)) {
                tree = store.query.parseReactElement(result).toNodeTree();
              } else {
                tree = result;
              }
            } else {
              tree = store.query.parseReactElement(userElement).toNodeTree();
            }
            const dom = e.currentTarget;
            this.draggedElementShadow = createShadow(
              e,
              [dom],
              _DefaultEventHandlers.forceSingleDragShadow
            );
            this.dragTarget = {
              type: "new",
              tree
            };
            this.positioner = new Positioner(
              this.options.store,
              this.dragTarget
            );
          }
        );
        const unbindDragEnd = this.addCraftEventListener(el, "dragend", (e) => {
          e.craft.stopPropagation();
          this.dropElement((dragTarget, indicator) => {
            if (dragTarget.type === "existing") {
              return;
            }
            const index = indicator.placement.index + (indicator.placement.where === "after" ? 1 : 0);
            store.actions.addNodeTree(
              dragTarget.tree,
              indicator.placement.parent.id,
              index
            );
            if (options && lodash_isfunction_default()(options.onCreate)) {
              options.onCreate(dragTarget.tree);
            }
          });
        });
        return () => {
          el.removeAttribute("draggable");
          unbindDragStart();
          unbindDragEnd();
        };
      }
    };
  }
  dropElement(onDropNode) {
    const store = this.options.store;
    if (!this.positioner) {
      return;
    }
    const draggedElementShadow = this.draggedElementShadow;
    const indicator = this.positioner.getIndicator();
    if (this.dragTarget && indicator && !indicator.error) {
      onDropNode(this.dragTarget, indicator);
    }
    if (draggedElementShadow) {
      draggedElementShadow.parentNode.removeChild(draggedElementShadow);
      this.draggedElementShadow = null;
    }
    this.dragTarget = null;
    store.actions.setIndicator(null);
    store.actions.setNodeEvent("dragged", null);
    this.positioner.cleanup();
    this.positioner = null;
  }
};
let DefaultEventHandlers = _DefaultEventHandlers;
DefaultEventHandlers.forceSingleDragShadow = (0,platform_es/* isChromium */.mJ)() && (0,platform_es/* isLinux */.IJ)();




/***/ }),

/***/ 732789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ EventHandlerContext; },
/* harmony export */   "x": function() { return /* binding */ useEventHandler; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const EventHandlerContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useEventHandler = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EventHandlerContext);




/***/ }),

/***/ 581906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ findPosition; }
/* harmony export */ });
function findPosition(parent, dims, posX, posY) {
  const result = {
    parent,
    index: 0,
    where: "before"
  };
  let leftLimit = 0, xLimit = 0, dimRight = 0, yLimit = 0, xCenter = 0, yCenter = 0, dimDown = 0;
  for (let i = 0, len = dims.length; i < len; i++) {
    const dim = dims[i];
    dimRight = dim.left + dim.outerWidth;
    dimDown = dim.top + dim.outerHeight;
    xCenter = dim.left + dim.outerWidth / 2;
    yCenter = dim.top + dim.outerHeight / 2;
    if (xLimit && dim.left > xLimit || yLimit && yCenter >= yLimit || leftLimit && dimRight < leftLimit)
      continue;
    result.index = i;
    if (!dim.inFlow) {
      if (posY < dimDown)
        yLimit = dimDown;
      if (posX < xCenter) {
        xLimit = xCenter;
        result.where = "before";
      } else {
        leftLimit = xCenter;
        result.where = "after";
      }
    } else {
      if (posY < yCenter) {
        result.where = "before";
        break;
      } else
        result.where = "after";
    }
  }
  return result;
}




/***/ }),

/***/ 883700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useNode; }
/* harmony export */ });
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(182052);
/* harmony import */ var _nodes_useInternalNode_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(131817);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function useNode(collect) {
  const _a = (0,_nodes_useInternalNode_es_js__WEBPACK_IMPORTED_MODULE_0__/* .useInternalNode */ .Z)(collect), { id, related, actions, inNodeContext, connectors } = _a, collected = __objRest(_a, ["id", "related", "actions", "inNodeContext", "connectors"]);
  return __spreadProps(__spreadValues({}, collected), {
    actions,
    id,
    related,
    setProp: (cb, throttleRate) => {
      (0,_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .deprecationWarning */ .d)("useNode().setProp()", {
        suggest: "useNode().actions.setProp()"
      });
      return actions.setProp(cb, throttleRate);
    },
    inNodeContext,
    connectors
  });
}




/***/ }),

/***/ 950696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ActionMethodsWithConfig": function() { return /* reexport */ store_es/* ActionMethodsWithConfig */.LO; },
  "Canvas": function() { return /* reexport */ Canvas_es/* Canvas */.X; },
  "CoreEventHandlers": function() { return /* reexport */ CoreEventHandlers_es/* CoreEventHandlers */.D; },
  "DefaultEventHandlers": function() { return /* reexport */ DefaultEventHandlers_es/* DefaultEventHandlers */.q; },
  "DerivedCoreEventHandlers": function() { return /* reexport */ CoreEventHandlers_es/* DerivedCoreEventHandlers */.s; },
  "Editor": function() { return /* reexport */ Editor; },
  "Element": function() { return /* reexport */ Element_es/* Element */.W_; },
  "Events": function() { return /* reexport */ Events; },
  "Frame": function() { return /* reexport */ Frame_es/* Frame */.R; },
  "LAZY_RENDERING_CONFIG": function() { return /* reexport */ LazyNodeElement_es/* LAZY_RENDERING_CONFIG */.F; },
  "LazyNodeElement": function() { return /* reexport */ LazyNodeElement_es/* LazyNodeElement */.U; },
  "NODE_EVENT_TYPES": function() { return /* reexport */ NODE_EVENT_TYPES; },
  "NodeElement": function() { return /* reexport */ NodeElement_es/* NodeElement */.V; },
  "NodeHelpers": function() { return /* reexport */ NodeHelpers_es/* NodeHelpers */.a; },
  "NodeProvider": function() { return /* reexport */ NodeContext_es/* NodeProvider */.c; },
  "NodeSelectorType": function() { return /* reexport */ nodes_es/* NodeSelectorType */.F; },
  "PerformanceTracker": function() { return /* reexport */ PerformanceTracker_es/* PerformanceTracker */.a; },
  "QueryMethods": function() { return /* reexport */ query_es/* QueryMethods */.n; },
  "ROOT_NODE": function() { return /* reexport */ constants_es/* ROOT_NODE */.QS; },
  "ViewportProvider": function() { return /* reexport */ ViewportContext_es/* ViewportProvider */.j; },
  "connectEditor": function() { return /* reexport */ connectEditor; },
  "connectNode": function() { return /* reexport */ connectNode; },
  "createTestNodes": function() { return /* reexport */ testHelpers_es/* createTestNodes */.fj; },
  "createTestState": function() { return /* reexport */ testHelpers_es/* createTestState */.yY; },
  "defaultElementProps": function() { return /* reexport */ Element_es/* defaultElementProps */.WP; },
  "deprecateCanvasComponent": function() { return /* reexport */ Canvas_es/* deprecateCanvasComponent */.O; },
  "editorInitialState": function() { return /* reexport */ store_es/* editorInitialState */.OI; },
  "elementPropToNodeData": function() { return /* reexport */ Element_es/* elementPropToNodeData */.D5; },
  "expectEditorState": function() { return /* reexport */ testHelpers_es/* expectEditorState */.Mo; },
  "serializeNode": function() { return /* reexport */ serializeNode_es/* serializeNode */.U; },
  "useEditor": function() { return /* reexport */ useEditor; },
  "useEditorStore": function() { return /* reexport */ store_es/* useEditorStore */.Eh; },
  "useEventHandler": function() { return /* reexport */ EventContext_es/* useEventHandler */.x; },
  "useNode": function() { return /* reexport */ useNode_es/* useNode */.Z; },
  "useViewport": function() { return /* reexport */ ViewportContext_es/* useViewport */.S; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/testHelpers.es.js
var testHelpers_es = __webpack_require__(150179);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/constants.es.js
const NODE_EVENT_TYPES = {
  SELECTED: "selected",
  HOVERED: "hovered",
  DRAGGED: "dragged"
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/utils/serializeNode.es.js
var serializeNode_es = __webpack_require__(832760);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/constants.es.js
var constants_es = __webpack_require__(60599);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/NodeContext.es.js
var NodeContext_es = __webpack_require__(766911);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/Canvas.es.js
var Canvas_es = __webpack_require__(483011);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/Element.es.js + 1 modules
var Element_es = __webpack_require__(945607);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/NodeElement.es.js + 3 modules
var NodeElement_es = __webpack_require__(773855);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/LazyNodeElement.es.js
var LazyNodeElement_es = __webpack_require__(879577);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/ViewportContext.es.js
var ViewportContext_es = __webpack_require__(814409);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/render/PerformanceTracker.es.js
var PerformanceTracker_es = __webpack_require__(566414);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/render/Frame.es.js
var Frame_es = __webpack_require__(576344);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/interfaces/nodes.es.js
var nodes_es = __webpack_require__(609705);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/useInternalEditor.es.js
var useInternalEditor_es = __webpack_require__(210289);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/hooks/useEditor.es.js



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getPublicActions = (actions) => {
  const _a = actions, EditorActions = __objRest(_a, [
    "addLinkedNodeFromTree",
    "setDOM",
    "setNodeEvent",
    "replaceNodes",
    "reset"
  ]);
  return EditorActions;
};
function useEditor(collect) {
  const _a = (0,useInternalEditor_es/* useInternalEditor */._)(collect), {
    connectors,
    actions: internalActions,
    query,
    store
  } = _a, collected = __objRest(_a, [
    "connectors",
    "actions",
    "query",
    "store"
  ]);
  const EditorActions = getPublicActions(internalActions);
  const actions = (0,react.useMemo)(() => {
    return __spreadProps(__spreadValues({}, EditorActions), {
      history: __spreadProps(__spreadValues({}, EditorActions.history), {
        ignore: (...args) => getPublicActions(EditorActions.history.ignore(...args)),
        throttle: (...args) => getPublicActions(EditorActions.history.throttle(...args))
      })
    });
  }, [EditorActions]);
  return __spreadValues({
    connectors,
    actions,
    query,
    store
  }, collected);
}



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/hooks/useNode.es.js
var useNode_es = __webpack_require__(883700);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/hooks/legacy/connectEditor.es.js



var connectEditor_es_defProp = Object.defineProperty;
var connectEditor_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var connectEditor_es_hasOwnProp = Object.prototype.hasOwnProperty;
var connectEditor_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var connectEditor_es_defNormalProp = (obj, key, value) => key in obj ? connectEditor_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var connectEditor_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (connectEditor_es_hasOwnProp.call(b, prop))
      connectEditor_es_defNormalProp(a, prop, b[prop]);
  if (connectEditor_es_getOwnPropSymbols)
    for (var prop of connectEditor_es_getOwnPropSymbols(b)) {
      if (connectEditor_es_propIsEnum.call(b, prop))
        connectEditor_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function connectEditor(collect) {
  return (WrappedComponent) => {
    return (props) => {
      const Editor = collect ? useEditor(collect) : useEditor();
      return /* @__PURE__ */ (0,jsx_runtime.jsx)(WrappedComponent, connectEditor_es_spreadValues(connectEditor_es_spreadValues({}, Editor), props));
    };
  };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/hooks/legacy/connectNode.es.js



var connectNode_es_defProp = Object.defineProperty;
var connectNode_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var connectNode_es_hasOwnProp = Object.prototype.hasOwnProperty;
var connectNode_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var connectNode_es_defNormalProp = (obj, key, value) => key in obj ? connectNode_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var connectNode_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (connectNode_es_hasOwnProp.call(b, prop))
      connectNode_es_defNormalProp(a, prop, b[prop]);
  if (connectNode_es_getOwnPropSymbols)
    for (var prop of connectNode_es_getOwnPropSymbols(b)) {
      if (connectNode_es_propIsEnum.call(b, prop))
        connectNode_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function connectNode(collect) {
  return function(WrappedComponent) {
    return (props) => {
      const node = (0,useNode_es/* useNode */.Z)(collect);
      return /* @__PURE__ */ (0,jsx_runtime.jsx)(WrappedComponent, connectNode_es_spreadValues(connectNode_es_spreadValues({}, node), props));
    };
  };
}



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/History.es.js
var History_es = __webpack_require__(157658);
// EXTERNAL MODULE: ../../.yarn/cache/lodash.pickby-npm-4.6.0-84e9fee0d5-a554d898c1.zip/node_modules/lodash.pickby/index.js
var lodash_pickby = __webpack_require__(16044);
var lodash_pickby_default = /*#__PURE__*/__webpack_require__.n(lodash_pickby);
// EXTERNAL MODULE: ../../.yarn/cache/tiny-invariant-npm-1.2.0-024338c59c-e09a718a7c.zip/node_modules/tiny-invariant/dist/tiny-invariant.esm.js
var tiny_invariant_esm = __webpack_require__(668564);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/EditorContext.es.js
var EditorContext_es = __webpack_require__(509107);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/store.es.js + 1 modules
var store_es = __webpack_require__(185105);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/EventContext.es.js
var EventContext_es = __webpack_require__(732789);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/RenderIndicator.es.js
var RenderIndicator_es = __webpack_require__(748357);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/getDOMInfo.es.js
var getDOMInfo_es = __webpack_require__(914785);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/movePlaceholder.es.js
function movePlaceholder(pos, canvasDOMInfo, bestTargetDomInfo, thickness = 2) {
  let t = 0, l = 0, w = 0, h = 0;
  const where = pos.where;
  const elDim = bestTargetDomInfo;
  if (elDim) {
    if (!elDim.inFlow) {
      w = thickness;
      h = elDim.outerHeight;
      t = elDim.top;
      l = where === "before" ? elDim.left : elDim.left + elDim.outerWidth;
    } else {
      w = elDim.outerWidth;
      h = thickness;
      t = where === "before" ? elDim.top : elDim.bottom;
      l = elDim.left;
    }
  } else {
    if (canvasDOMInfo) {
      t = canvasDOMInfo.top + canvasDOMInfo.padding.top;
      l = canvasDOMInfo.left + canvasDOMInfo.padding.left;
      w = canvasDOMInfo.outerWidth - canvasDOMInfo.padding.right - canvasDOMInfo.padding.left - canvasDOMInfo.margin.left - canvasDOMInfo.margin.right;
      h = thickness;
    }
  }
  return {
    top: `${t}px`,
    left: `${l}px`,
    width: `${w}px`,
    height: `${h}px`
  };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/RenderEditorIndicator.es.js






var RenderEditorIndicator_es_defProp = Object.defineProperty;
var RenderEditorIndicator_es_defProps = Object.defineProperties;
var RenderEditorIndicator_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var RenderEditorIndicator_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var RenderEditorIndicator_es_hasOwnProp = Object.prototype.hasOwnProperty;
var RenderEditorIndicator_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var RenderEditorIndicator_es_defNormalProp = (obj, key, value) => key in obj ? RenderEditorIndicator_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var RenderEditorIndicator_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (RenderEditorIndicator_es_hasOwnProp.call(b, prop))
      RenderEditorIndicator_es_defNormalProp(a, prop, b[prop]);
  if (RenderEditorIndicator_es_getOwnPropSymbols)
    for (var prop of RenderEditorIndicator_es_getOwnPropSymbols(b)) {
      if (RenderEditorIndicator_es_propIsEnum.call(b, prop))
        RenderEditorIndicator_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var RenderEditorIndicator_es_spreadProps = (a, b) => RenderEditorIndicator_es_defProps(a, RenderEditorIndicator_es_getOwnPropDescs(b));
const RenderEditorIndicator = () => {
  const { indicator, indicatorOptions, enabled } = (0,useInternalEditor_es/* useInternalEditor */._)(
    (state) => ({
      indicator: state.indicator,
      indicatorOptions: state.options.indicator,
      enabled: state.options.enabled
    })
  );
  const handler = (0,EventContext_es/* useEventHandler */.x)();
  (0,react.useEffect)(() => {
    if (!handler) {
      return;
    }
    if (!enabled) {
      handler.disable();
      return;
    }
    handler.enable();
  }, [enabled, handler]);
  if (!indicator) {
    return null;
  }
  return react.createElement(RenderIndicator_es/* RenderIndicator */.n, {
    style: RenderEditorIndicator_es_spreadProps(RenderEditorIndicator_es_spreadValues({}, movePlaceholder(
      indicator.placement,
      (0,getDOMInfo_es/* getDOMInfo */.e)(indicator.placement.parent.dom),
      indicator.placement.currentNode && (0,getDOMInfo_es/* getDOMInfo */.e)(indicator.placement.currentNode.dom),
      indicatorOptions.thickness
    )), {
      backgroundColor: indicator.error ? indicatorOptions.error : indicatorOptions.success,
      transition: indicatorOptions.transition || "0.2s ease-in"
    }),
    parentDom: indicator.placement.parent.dom
  });
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/Events.es.js






const Events = ({ children }) => {
  const store = (0,react.useContext)(EditorContext_es/* EditorContext */.r);
  const handler = (0,react.useMemo)(
    () => store.query.getOptions().handlers(store),
    [store]
  );
  if (!handler) {
    return null;
  }
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(EventContext_es/* EventHandlerContext.Provider */.G.Provider, {
    value: handler,
    children: [
      /* @__PURE__ */ (0,jsx_runtime.jsx)(RenderEditorIndicator, {}),
      children
    ]
  });
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/Editor.es.js









var Editor_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Editor_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Editor_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Editor_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Editor_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Editor_es_getOwnPropSymbols)
    for (var prop of Editor_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Editor_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Editor = ({
  children,
  onRender,
  onNodesChange,
  onBeforeMoveEnd,
  resolver,
  enabled,
  indicator
}) => {
  if (resolver !== void 0) {
    (0,tiny_invariant_esm/* default */.Z)(
      typeof resolver === "object" && !Array.isArray(resolver),
      constants_es/* ERROR_RESOLVER_NOT_AN_OBJECT */.lq
    );
  }
  const options = (0,react.useMemo)(() => {
    return lodash_pickby_default()(
      {
        onRender,
        onNodesChange,
        onBeforeMoveEnd,
        resolver,
        enabled,
        indicator
      },
      (value) => value !== void 0
    );
  }, [enabled, indicator, onBeforeMoveEnd, onNodesChange, onRender, resolver]);
  const context = (0,store_es/* useEditorStore */.Eh)(
    options,
    (state, previousState, actionPerformedWithPatches, query, normalizer) => {
      if (!actionPerformedWithPatches) {
        return;
      }
      const _a = actionPerformedWithPatches, { patches } = _a, actionPerformed = Editor_es_objRest(_a, ["patches"]);
      for (let i = 0; i < patches.length; i++) {
        const { path } = patches[i];
        const isModifyingNodeData = path.length > 2 && path[0] === "nodes" && path[2] === "data";
        const actionType = actionPerformed.type;
        if ([History_es/* HISTORY_ACTIONS.IGNORE */.G.IGNORE, History_es/* HISTORY_ACTIONS.THROTTLE */.G.THROTTLE].includes(
          actionType
        ) && actionPerformed.params) {
          actionPerformed.type = actionPerformed.params[0];
        }
        if (["setState", "deserialize"].includes(actionPerformed.type) || isModifyingNodeData) {
          normalizer((draft) => {
            if (state.options.normalizeNodes) {
              state.options.normalizeNodes(
                draft,
                previousState,
                actionPerformed,
                query
              );
            }
          });
          break;
        }
      }
    }
  );
  (0,react.useEffect)(() => {
    if (context && options) {
      context.actions.setOptions((editorOptions) => {
        Object.assign(editorOptions, options);
      });
    }
  }, [context, options]);
  (0,react.useEffect)(() => {
    if (!context.query.getOptions().onNodesChange) {
      return;
    }
    const unsubscribe = context.subscribe(
      (_) => ({
        json: context.query.serialize()
      }),
      () => {
        context.query.getOptions().onNodesChange(context.query);
      }
    );
    return () => {
      if (unsubscribe) {
        return unsubscribe();
      }
    };
  }, [context]);
  return context ? /* @__PURE__ */ (0,jsx_runtime.jsx)(EditorContext_es/* EditorContext.Provider */.r.Provider, {
    value: context,
    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Events, {
      children
    })
  }) : null;
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/query.es.js + 1 modules
var query_es = __webpack_require__(596509);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/NodeHelpers.es.js
var NodeHelpers_es = __webpack_require__(892274);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/CoreEventHandlers.es.js
var CoreEventHandlers_es = __webpack_require__(844710);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/events/DefaultEventHandlers.es.js + 2 modules
var DefaultEventHandlers_es = __webpack_require__(343216);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/index.es.js



























/***/ })

}]);